import { apiGet } from '../../../adapters/api-client/api';

export type SessionState =
  | 'Scheduled'
  | 'InProgress'
  | 'AwaitingValidation'
  | 'Completed'
  | 'Disputed'
  | 'NotDelivered';

export interface HoldbackView {
  holdbackReleased: boolean;
  holdbackReleaseAt?: string;
  holdbackReleasable: boolean;
}

export interface CycleProgressMilestone {
  sequence: number;
  type: 'session' | 'final_project';
  status: string;
  sessionState: SessionState;
  scheduledStart?: string;
  completedAt?: string;
  releasedAt?: string;
  releaseAmount: number;
  bookingId?: string;
  bookingState?: string;
}

export interface CycleProgress {
  enrollmentId: string;
  state: string;
  progress: { completed: number; total: number };
  holdback: HoldbackView;
  milestones: CycleProgressMilestone[];
}

export function getCycleProgress(enrollmentId: string): Promise<CycleProgress> {
  return apiGet(`/api/v1/enrollments/${enrollmentId}/cycle-progress`);
}
